import { render } from "./StartPoint.vue?vue&type=template&id=fed289aa&scoped=true"
import script from "./StartPoint.vue?vue&type=script&lang=js"
export * from "./StartPoint.vue?vue&type=script&lang=js"

import "./StartPoint.vue?vue&type=style&index=0&id=fed289aa&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fed289aa"]])

export default __exports__